import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilCalculator,
  cilCalendar,
  cilChartPie,
  cilCursor,
  cilDrop,
  cilEnvelopeOpen,
  cilGrid,
  cilLayers,
  cilMap,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react-pro'

const _navAccount = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    badge: {
      color: 'info-gradient',
    },
  },
  {
    component: CNavGroup,
    name: 'Payment and Transaction',
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
    requiredPermission: 'TRANSACTION',
    items: [
      {
        component: CNavItem,
        name: 'View Transaction',
        to: '/transactions',
        requiredPermission: 'TRANSACTION',
        requiredPrivilege: 'VIEW',
      },
    ],
  },
  {
    component: CNavItem,
    name: 'Log out',
    to: '/logout',
    icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
  },
]

export default _navAccount
